import React, { useState, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import CommitedExpendituresIndexListEditModal from './CommittedExpendituresIndexListEditModal';
import CommittedExpendituresIndexTableRow from './CommittedExpendituresIndexTableRow';

import { modalOptions } from 'Helpers/modalOptions';

import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';

export default function CommittedExpendituresIndexList(props) {
    const [committedExpenditures, setCommittedExpenditures] = useState([]);
    const [updatedCommittedExpenditure, setUpdatedCommittedExpenditure] = useState([]);
    const [updatedCommittedExpensable, setUpdatedCommittedExpensable] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [isLoading, setIsLoading] = useState(1);
    const [isRequesting, setIsRequesting] = useState(1);
    const [commitedExpendituresIndexListEditModalElement, setCommitedExpendituresIndexListEditModalElement] = useState(null);

    const commitedExpendituresIndexListEditModalRef = useRef();

    useEffect(() => {
        fetchCommittedExpenditures();
        fetchSuppliers();
        commitedExpendituresIndexListEditModalRef &&
            setCommitedExpendituresIndexListEditModalElement(new Modal(commitedExpendituresIndexListEditModalRef.current, modalOptions(false)));
    }, []);

    useEffect(() => {
        if (Object.keys(updatedCommittedExpenditure).length > 0) {
            commitedExpendituresIndexListEditModalElement && commitedExpendituresIndexListEditModalElement.show();
        }
    }, [updatedCommittedExpenditure]);

    const fetchCommittedExpenditures = () => {
        setIsLoading(true);

        axios
            .untranslated()
            .get(props.committedExpendituresIndexUrl)
            .then((res) => {
                const { data, to, from, total, last_page } = res.data;
                setCommittedExpenditures(data);
                setTo(to);
                setFrom(from);
                setTotal(total);
                setLastPage(last_page);
                setIsLoading(false);
            })
            .catch((error) => {
                setCommittedExpenditures([]);
                setIsLoading(false);
            });
    };

    const fetchSuppliers = () => {
        axios
            .get(props.suppliersIndexUrl + '?without_pagination=1')
            .then((res) => {
                setSuppliers(res.data);
            })
            .catch((error) => {
                setSuppliers([]);
            });
    };

    const clickRow = (committedExpenditure, committedExpensable = undefined) => {
        if (committedExpenditure.expense.type == 'template' || committedExpenditure.expense.type == 'project') {
            window.location.href = committedExpendituresIndexUrl + '&committed_expenditure_id=' + committedExpenditure.id;
        } else {
            setUpdatedCommittedExpenditure(committedExpenditure);
            setUpdatedCommittedExpensable(committedExpensable);
        }
    };

    const successHandler = () => {
        commitedExpendituresIndexListEditModalElement && commitedExpendituresIndexListEditModalElement.hide();
        setCommittedExpenditures([]);
        fetchCommittedExpenditures();
    };

    const pageChange = (data) => {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchSuppliers(url);
    };

    return (
        <>
            <div id={'committed-expenditures-table'} className={'table-responsive'}>
                <table className={'my-3 table  table-bordered no-footer'}>
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Expense</th>
                            <th style={{ width: '10%' }}>Total</th>
                            <th style={{ width: '20%' }}>Supplier</th>
                            <th style={{ width: '20%' }}>Contract Reference</th>
                            <th style={{ width: '20%' }}>Actions</th>
                        </tr>
                    </thead>
                    {!isLoading && committedExpenditures.length > 0 && (
                        <tbody>
                            {committedExpenditures.map((committedExpenditure) => {
                                return (
                                    <CommittedExpendituresIndexTableRow
                                        key={committedExpenditure.id}
                                        committedExpenditure={committedExpenditure}
                                        committedExpendituresIndexUrl={props.committedExpendituresIndexUrl}
                                        uncommittedExpendituresCreateUrl={props.uncommittedExpendituresCreateUrl}
                                        uncommittedExpendituresDetailsUrl={props.uncommittedExpendituresDetailsUrl}
                                        clickRow={clickRow}
                                    />
                                );
                            })}
                        </tbody>
                    )}
                    {isLoading && (
                        <tbody>
                            <tr>
                                <td colSpan="5">Loading...</td>
                            </tr>
                        </tbody>
                    )}
                    {!isLoading && committedExpenditures.length === 0 && (
                        <tbody>
                            <tr>
                                <td colSpan="5">
                                    <a className={'mr-3 font-italic'} href={props.uncommittedExpendituresCreateUrl}>
                                        No Committed Expenditures found click here to Commit Expenditures
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
                <div className={'d-flex justify-content-between align-items-center pb-5'}>
                    <PaginationInfo to={to} from={from} total={total} entries={'suppliers'} />
                    <TablePagination lastPage={lastPage} pageChange={pageChange} />
                </div>
                <CommitedExpendituresIndexListEditModal
                    modalId="edit-committed-expenditure"
                    modalRef={commitedExpendituresIndexListEditModalRef}
                    modalElement={commitedExpendituresIndexListEditModalElement}
                    committedExpenditure={updatedCommittedExpenditure}
                    committedExpensable={updatedCommittedExpensable}
                    suppliers={suppliers}
                    successHandler={successHandler}
                    committedExpendituresUpdateUrl={props.committedExpendituresUpdateUrl}
                />
            </div>
        </>
    );
}
